module.exports = __webpack_public_path__ + "static/media/help-3.8a36d3fb.svg";